import Drawer, { type DrawerContentComponentProps } from 'expo-router/drawer';
import NavigationPanel from './NavigationPanel';
import NavigationPanelTabElement from './NavigationPanelTabElement';
import TopAndBottomView from './TopAndBottomView';
import { DRAWER_WIDTH } from '../../constants/layout';
import { Fragment, useContext } from 'react';
import { NavigationMenuVisibilityContext } from './NavigationMenuVisibilityContext';
import { assistanceStackKey, dashboardStackKey, faceScanStackKey, healthStackKey, libraryStackKey, reckoningResultKey, sessionStackKey, settingStackKey } from '../../constants/routeKeys';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';

export const bottomTabKeys= [settingStackKey];

export const excludeTabKeys = [sessionStackKey, faceScanStackKey, reckoningResultKey];

const DrawerNavigationInner = observer(({state} : DrawerContentComponentProps) => {
  const { user } = useStores();
  const faceScanDisabled = user?.company?.hasAccessToFaceScan === false;
  const hiddenKeys = faceScanDisabled ? [...excludeTabKeys, healthStackKey] : excludeTabKeys;
  const topScreens = state.routes.filter(r => !bottomTabKeys.includes(r.name) && !hiddenKeys.includes(r.name));
  const bottomScreens = state.routes.filter(r => bottomTabKeys.includes(r.name));
  const activeRouteKey = state.routes[state.index]?.name;
  const { visible } = useContext(NavigationMenuVisibilityContext);

  const topTabOrder = [dashboardStackKey, libraryStackKey, assistanceStackKey, healthStackKey];
  const topScreensSorted= topScreens.sort((a, b) => {
    const aIdx = topTabOrder.indexOf(a.name);
    const bIdx = topTabOrder.indexOf(b.name);
    return (aIdx === -1 ? Infinity : aIdx) - (bIdx === -1 ? Infinity : bIdx);
  });


  if (!visible) return null;
  return (
    <NavigationPanel>
      <TopAndBottomView
        topChildren={
          <>
            {topScreensSorted.map((t, idx) => {
              return (
                <Fragment key={idx}>
                  <NavigationPanelTabElement key={idx} labelKey={t.name} selected={activeRouteKey === t.name} />
                </Fragment>
              );
            })}
          </>
        }
        bottomChildren={
          <>
            {bottomScreens.map((t, idx) => {
              return (
                <Fragment key={idx}>
                  <NavigationPanelTabElement key={idx} labelKey={t.name} selected={activeRouteKey === t.name} />
                </Fragment>
              );
            })}
          </>
        }
      />
    </NavigationPanel>
  );
});

export const DrawerNavigation = (props: DrawerContentComponentProps) => <DrawerNavigationInner {...props} />;

const _NavigationPrivateWeb = () => {
  const { visible } = useContext(NavigationMenuVisibilityContext);
  const widthWithVisibility = visible ? DRAWER_WIDTH : 0;

  return (
    <Drawer
      initialRouteName={dashboardStackKey}
      defaultStatus={'open'}
      drawerContent={DrawerNavigation}
      screenOptions={{
        drawerStyle: {
          width: widthWithVisibility,
        },
        drawerType: 'permanent',
        drawerStatusBarAnimation: 'slide',
        headerShown: false,
      }}
    />
  );
};

export const NavigationPrivateWeb = observer(_NavigationPrivateWeb);
